import { Endpoint } from './../../../constants/endpoints';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Value } from '@philips-internal/oswald-ui-core';

export interface ManagementSolution {
  [key: string]: Record<string, Value>;
}

export interface SolutionPartialVolumeParameters {
  encounterNumber: number;
  justificationDescription?: string;
  prescriptionNumber: number;
  solutionSequence: number;
  volumeDate: string;
  volumePhase: number;
  volumeQuantity: number;
}

export interface GenerateChangePrescribedSolutionParams {
  changeDate: string;
  discardedVolumeQuantity: number;
  dosageType: string;
  encounterNumber: number;
  infusedVolumeQuantity: number;
  infusionSpeedQuantity: number;
  observationDescription: string;
  partialVolumeQuantity: number;
  prescriptionNumber: number;
  reasonSequence: number;
  solutionSequence: number;
  volumePhaseQuantity: number;
}

interface GenerateChangePrescribedSolutionResponse {
  messageDescription: string;
}

export default class SolutionService {

  public getManagementSolution(prescriptionNumber: number, solutionSequence: number): Promise<ManagementSolution> {
    return HttpService.get(
      Endpoint.EMAR_GET_MANAGEMENT_SOLUTION,
      { prescriptionNumber, solutionSequence }
    ).then(response => {
      return response.body as ManagementSolution
    });
  }

  public registerPartialVolumeSolution(params: SolutionPartialVolumeParameters): void {
    const body = Object.assign({}, params) as unknown as Record<string, Value>;

    HttpService.post(
      Endpoint.EMAR_REGISTER_PARTIAL_VOLUME_SOLUTION, {},
      { body }
    );
  }

  public GenerateChangePrescribedSolution(params: GenerateChangePrescribedSolutionParams): Promise<GenerateChangePrescribedSolutionResponse> {
    const body = Object.assign({}, params) as unknown as Record<string, Value>;

    return HttpService.post(
      Endpoint.EMAR_GENERATE_CHANGE_PRESCRIBED_SOLUTION, {},
      { body }
    ).then(response => {
      return response.body as GenerateChangePrescribedSolutionResponse;
    }).catch(err => {
      return { messageDescription: err.body?.errors?.join(' \n') };
    });

  }

}

